import { render } from "./StartClaimComponent.vue?vue&type=template&id=eebbecde&scoped=true"
import script from "./StartClaimComponent.vue?vue&type=script&lang=js"
export * from "./StartClaimComponent.vue?vue&type=script&lang=js"

import "./StartClaimComponent.vue?vue&type=style&index=0&id=eebbecde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eebbecde"]])

export default __exports__